import React, { useEffect, useState } from 'react';
import fr from 'facet-rest';
import moment from 'moment-timezone';
import { useHistory } from 'react-router';
import PreviewGraphImage from 'Assets/Images/selected-scenario.png';
import Image from 'Components/ComponentLibrary/Atoms/Image';
import StackItem from 'Components/ComponentLibrary/Atoms/Layout/StackItem';
import VerticalStack from 'Components/ComponentLibrary/Atoms/Layout/VerticalStack';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import Transition from 'Components/ComponentLibrary/Atoms/Transition';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import Container from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Container';
import HeaderBar from 'Components/ComponentLibrary/Molecules/HeaderBar';
import PointsOfInterestCard from 'Components/ComponentLibrary/Molecules/PointsOfInterestCard';
import StepNavigator from 'Components/ComponentLibrary/Molecules/StepNavigator';
import { dashboardWithModal } from 'Consts/clientUris';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import FacetFacNegative from 'Icons/Brand/FacetFacNegative';

const FacetPlanCongratulationsTemplate = () => {
  const history = useHistory();
  const { pageContentResource } = usePageContentContext();
  const { householdResource, householdLoading } = useSimpleHousehold();
  const [nextProjectedMeeting, setNextProjectedMeeting] = useState();
  const isLoading = nextProjectedMeeting === null;

  const fetchNextProjectMeeting = async resource => {
    const [resNextProjectedMeeting] = await resource
      ?.relationship(fr.relationships.projectedMeetings.name)
      .link('related')
      .Get({
        params: {
          tz: moment.tz.guess(),
        },
      });
    setNextProjectedMeeting(resNextProjectedMeeting);
  };

  const handleNext = () => {
    const nextUrl = dashboardWithModal('clientSchedulerModal', {
      link: nextProjectedMeeting
        ?.relationship(fr.relationships.projectedMeetingAvailabilityPeriod.name)
        .link('related')
        .url(),
    });

    history.push(nextUrl);
  };

  useEffect(() => {
    if (householdResource) {
      fetchNextProjectMeeting(householdResource);
    }
  }, [householdLoading]);

  // TODO: move to server
  const nextSteps = [
    'Your planner will review your selections and share action items',
    "You'll start making progress toward the lifestyle you want by checking off your to-do’s",
    'At your next meeting, you and your planner will review how things are going and adjust as needed',
  ];

  return (
    <VerticalStack height="screen" spacing={3}>
      <StackItem>
        <HeaderBar title={'Scenario Selection'} />
      </StackItem>
      <StackItem fillsSpace>
        <Transition>
          <Container maxWidth="xs">
            <VerticalStack spacing={3}>
              <StackItem>
                <Box align="center">
                  <FacetFacNegative
                    style={{
                      width: 60,
                      height: '100%',
                    }}
                  />
                </Box>
              </StackItem>
              <StackItem>
                <Text
                  align="center"
                  text={pageContentResource.attr('title')}
                  variant="h1"
                  weight="bold"
                />
              </StackItem>
              <StackItem>
                <Text
                  align="center"
                  color="mediumGray"
                  text={pageContentResource.attr('subtitle')}
                  variant="h5"
                />
              </StackItem>
              <StackItem>
                <Box mx="auto" width={2 / 3}>
                  <Image alt="Preview Graph" src={PreviewGraphImage} />
                </Box>
              </StackItem>
              <StackItem>
                <Text
                  align="center"
                  color="mediumGray"
                  text={pageContentResource.attr('instructionTitle')}
                  variant="h5"
                />
              </StackItem>
              <StackItem>
                <PointsOfInterestCard pointsOfInterest={nextSteps} />
              </StackItem>
            </VerticalStack>
          </Container>
        </Transition>
      </StackItem>
      <StackItem position="bottom">
        <StepNavigator
          disabled={isLoading}
          isLoading={isLoading}
          onNext={handleNext}
        >
          {pageContentResource.attr('buttonLabel')}
        </StepNavigator>
      </StackItem>
    </VerticalStack>
  );
};

FacetPlanCongratulationsTemplate.defaultProps = {};

FacetPlanCongratulationsTemplate.propTypes = {};

export default FacetPlanCongratulationsTemplate;
